import {ezGlobals} from 'ez_globals';
import {apiPost} from 'api';
import {POST_REFER_A_FRIEND} from 'api/endpoints';
import {buildPromoAlert} from 'promos/build_promo_alert';

export const referAFriendAttribution = () => {
  const {referralCode: referral_code, rid, pc} = ezGlobals;

  if (referral_code) {
    apiPost(POST_REFER_A_FRIEND, {referral_code, rid, pc}).then(response =>
      response.json().then(json => pc && buildPromoAlert(json.promo)),
    );
  }
};
